import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ItemForm from '../../../components/forms/ItemForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/items/PostAction'
import ListLocationsAction from '../../../actions/locations/ListLinearAction'
import ListCompartmentsAction from '../../../actions/compartments/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateItemPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchLocations()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Pièce ajoutée.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(data)
  }

  render() {
    const withPlural = !this.props.withNumber
    return (
      <Popup
        header={`Créer une${withPlural ? 'des' : ''} pièce${withPlural ? 's' : ''}`}
        body={
          <ItemForm
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            product={this.props.product}
            withNumber={this.props.withNumber}
            locationsList={this.props.locationsList}
            locationsIsFetching={this.props.locationsIsFetching}
            fetchCompartments={this.props.fetchCompartments}
            compartmentsList={this.props.compartmentsList}
            compartmentsIsFetching={this.props.compartmentsIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

CreateItemPopup.propTypes = {
  // Properties
  product: PropTypes.object.isRequired,
  withNumber: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  locationsList: PropTypes.array,
  locationsIsFetching: PropTypes.bool.isRequired,
  compartmentsList: PropTypes.array,
  compartmentsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  post: PropTypes.func.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  fetchCompartments: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.items.post.isFetching,
    error: state.entities.items.post.error,
    locationsList: state.entities.locations.list.linear.data,
    locationsIsFetching: state.entities.locations.list.linear.isFetching,
    compartmentsList: state.entities.compartments.list.data,
    compartmentsIsFetching: state.entities.compartments.list.isFetching
  }),
  (dispatch) => ({
    post: (data) => (dispatch(PostAction({ data }))),
    fetchLocations: () => (dispatch(ListLocationsAction({}))),
    fetchCompartments: (id) => (dispatch(ListCompartmentsAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.ITEMS.POST)))
  })
)(CreateItemPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/items/CreateItemPopup.js